import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-view-skeleton-template',
  templateUrl: './single-view-skeleton-template.component.html',
  styleUrls: ['./single-view-skeleton-template.component.scss'],
})
export class SingleViewSkeletonTemplateComponent implements OnInit {
  @Input() typeName = '';
  dummyData: any[] = [];

  constructor() {}
  ngOnInit() {
    for (let i = 0; i < 5; i++) {
      this.dummyData.push({});
    }
  }
}
